const TiposMercado = {
      Cambio: 1,
      Ouro: 2,
      Cripto: 3,
      SeguroViagem: 4,
      ChipInternacional: 5
}


export default TiposMercado;